// 满意度统计页的数字格式 (从 satisfactionParts 拆出: 组件文件只导出组件, 保 fast refresh).

export function pct(v: number | null | undefined, digits = 1): string {
    return v == null ? '—' : `${(v * 100).toFixed(digits)}%`;
}

export function fmtN(n: number): string {
    if (n >= 1e8) return `${(n / 1e8).toFixed(2)} 亿`;
    if (n >= 1e4) return `${(n / 1e4).toFixed(n >= 1e6 ? 0 : 1)} 万`;
    return n.toLocaleString();
}
